import React from 'react';
// import SliderMain from '../components/SliderMain';
import FeatureBox from '../components/FeatureBox';
import CarouselCollection from '../components/ContentDesign';
import CarouselNew from '../components/ContentDesign';
import AuthorList from '../components/authorList';
import Catgor from '../components/Catgor';
import Footer from '../components/footer';
import SliderMainZero from "../components/SliderMainZero";
import SmartContracts from "../components/SmartContractsSection";
import Car from "../components/carSection";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import image from '../../assets/background.png'
import whiteh from '../../assets/white.png'
import white from  '../../assets/whiteh.png'
import Email from '../components/EmailCaptureForm'
import whitechurro from '../../assets/logowhite.png'
import App from '../components/HomePage/Main3D/App'
import { Overlay }  from '../components/HomePage/Main3D/Overlay'
import Index1 from '../components/HomePage/Main3D/index'


const home= () => (
  <div>
      <section className="jumbotron breadcumb no-bg h-vh" >
        <App/>
        <Overlay/>

         {/* <SliderMainZero/> */}
      </section>
    
  </div>
);
export default home;